const serviceData = [
    {
      id: 1,
      title: "home delivery",
      icon: "ri-map-pin-2-line",
      desc: "Tempor tempor sadipscing vero lorem sea, invidunt sed et eos ipsum et erat. Dolor ut duo sadipscing lorem. Gubergren gub",
    },
  
    {
      id: 2,
      title: "Unlimited Miles Car Service",
      icon: "ri-community-line",
      desc: "Tempor tempor sadipscing vero lorem sea, invidunt sed et eos ipsum et erat. Dolor ut duo sadipscing lorem. Gubergren gub",
    },
  
    {
      id: 3,
      title: "New cars",
      icon: "ri-roadster-line",
      desc: "Tempor tempor sadipscing vero lorem sea, invidunt sed et eos ipsum et erat. Dolor ut duo sadipscing lorem. Gubergren gub",
    },
  
    {
      id: 4,
      title: "Fast & Easy Booking",
      icon: "ri-timer-flash-line",
      desc: "Tempor tempor sadipscing vero lorem sea, invidunt sed et eos ipsum et erat. Dolor ut duo sadipscing lorem. Gubergren gub",
    },
  
    {
      id: 5,
      title: "Used cars",
      icon: "ri-roadster-line",
      desc: "Tempor tempor sadipscing vero lorem sea, invidunt sed et eos ipsum et erat. Dolor ut duo sadipscing lorem. Gubergren gub",
    },
  
    
  ];
  
  export default serviceData;